import ParticipantSideBadge from "../../../components/ParticipantSideBadge";
import { Avatar } from "../../../design/avatar";
import { TableRow, TableCell } from "../../../design/table";
import { Participant } from "../../../models/Participant";
import ParticipantRoleBadge from "../../../components/ParticipantRoleBadge";

interface Props {
  participant: Participant;
}

const ParticipantListItem: React.FC<Props> = ({ participant }) => {
  return (
    <TableRow key={participant._id} href={`/participant/${participant._id}`}>
      <TableCell className="flex gap-2">
        {participant.avatarUrl && (
          <Avatar src={participant.avatarUrl} className="size-6" />
        )}
        <div className="flex flex-col">
          <span className="font-bold">{participant.name}</span>
        </div>
      </TableCell>
      <TableCell>
        <ParticipantRoleBadge role={participant.role} />
      </TableCell>
      <TableCell>
        <ParticipantSideBadge side={participant.side} />
      </TableCell>
    </TableRow>
  );
};

export default ParticipantListItem;
